document.addEventListener( 'DOMContentLoaded', () => {

	const searchForms = document.querySelectorAll( '.search-container__form' );

	/**
	 * Creates a callback that clears the value of an input field and focuses it.
	 *
	 * @param {HTMLInputElement} input - The input element to be cleared and focused.
	 * @param {HTMLButtonElement} clearButton - The clear button element to show or hide.
	 * @return {Function} A function that clears the input value and sets focus on it.
	 */
	const clearInput = ( input, clearButton ) => {

		return () => {

			input.value = '';
			input.focus();
			toggleClearButton( input, clearButton )();

		}

	};


	/**
	 * Creates a callback that toggles the visibility of a clear button based on input value.
	 *
	 * @param {HTMLInputElement} input - The input element to monitor for value changes.
	 * @param {HTMLButtonElement} clearButton - The clear button element to show or hide.
	 * @return {Function} A function that shows the clear button when input has value, hides it when empty.
	 */
	const toggleClearButton = ( input, clearButton ) => {

		const hiddenClassName = 'search-container__clear-button--hidden';

		return () => {

			if ( input.value.length > 0 ) {

				clearButton.classList.remove( hiddenClassName );

			} else {

				clearButton.classList.add( hiddenClassName );

			}

		}

	}

	searchForms.forEach( form => {

		const input = form.querySelector( '.search-container__field' );
		const clearButton = form.querySelector( '.search-container__clear-button' );
		input.addEventListener( 'input', toggleClearButton( input, clearButton ) );
		clearButton.addEventListener( 'click', clearInput( input, clearButton ) );

	} );

} );